import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-form-field-input',
  templateUrl: './form-field-input.component.html',
  styleUrls: ['./form-field-input.component.scss'],
  providers:[
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormFieldInputComponent),
      multi: true
    }
  ]
})
export class FormFieldInputComponent implements OnInit {

  @Input() label!: string;
  @Input() required!: boolean;
  @Input() isInline!: boolean;
  @Input() control!: AbstractControl;
  @Input() patternError!: string;
  @Input() icon!: string;
  @Input() iconLabel!: boolean;
  @Input() readonly!: boolean;

  @Input() placeholder!: string;
  @Output() changed = new EventEmitter<string>();
  @Output() change = new EventEmitter<string>();

  value!: string;
  isDisabled!: boolean;

  constructor() { 
    this.isInline = true;
    this.readonly = false;
  }

  ngOnInit(): void {
  }

  hasError(): boolean{
    return this.control && this.control.invalid && this.control.touched;
  }

  get errorKey() {
    return this.control && this.control.errors && Object.keys(this.control.errors)[0];
  }

  private propagateChange: any = () => { };
  private propagateTouched: any = () => { };

  writeValue(value: string): void{
    this.value = value;
  }

  registerOnChange(fn: any): void{
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void{
    this.propagateTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void{
    this.isDisabled = isDisabled;
  }

  onKeyup(value: string): void {
    this.value = value;
    this.propagateChange(value);
    this.changed.emit(value);
  }

  onChange(value: string): void {
    this.change.emit(value);
  }

  onBlur(): void {
    this.propagateTouched();
  }

}